import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { equipmentInvoiceLineService } from 'shared/services';
import { Option } from 'shared/types/general';

interface EquipmentInvoiceLineFormParams {
  onSubmit: any;
  contractId: number;
}

function EquipmentInvoiceLineForm({ onSubmit, contractId }: EquipmentInvoiceLineFormParams) {
  const { t } = useTranslation();

  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    if (contractId) {
      equipmentInvoiceLineService.getUnassigned(10000, 0, { contract: contractId }).then((res) => {
        setOptions(
          res.results.map((cost) => {
            const typeString = t(`pages.equipment-invoices.detail.modes.${cost.type}` as any);
            const code = cost.contract_equipment ? cost.equipment : cost.code;
            const description = `${code} - ${cost.description}`;
            return {
              id: cost.id,
              code: `${description} ${cost.initialization_date}, € ${cost.expected_amount.replace(
                '.',
                ','
              )} (${typeString})`
            };
          })
        );
      });
    } else {
      setOptions([]);
    }
  }, [contractId]);

  return (
    <EnhancedForm onSubmit={onSubmit} formId="newInvoice" hideControls>
      <div className="flex flex-wrap">
        <div className="w-full p-2">
          <IdentityField
            name="invoice_line"
            component={AutocompleteAdapter}
            options={options}
            label={t('pages.equipment-invoices.detail.invoice-line')}
            validate={required}
            required
          />
        </div>
      </div>
    </EnhancedForm>
  );
}

export default EquipmentInvoiceLineForm;
